import moment from "moment";

export interface GoogleCalendarFeed {
  slug: string;
  calendar: string;
  title: string;
  active?: boolean;
  isFixed?: boolean;
  color: string;
}

export class GoogleCalendarImporter {
  private urlParams = [`key=${this.apiKey}`, `maxResults=300`, `singleEvents=True`, "orderBy=startTime"];

  constructor(private apiKey: string) {}

  getCalendar(calendar: GoogleCalendarFeed, p: string[] = []) {
    var url = `https://www.googleapis.com/calendar/v3/calendars/${calendar.calendar}/events?${this.urlParams.concat(p).join(
      "&"
    )}`;
    return fetch(url)
      .then(r => r.json())
      .then(r => r.items as GoogleCalendarEvent[] || [])
      .then(items => items.map(i => googleToBigEvent(i, calendar.slug)));
  }
}

export interface GoogleCalendarEvent {
  summary: string;
  description: string;
  start: {
    dateTime?: string;
    date?: string;
  };
  end: {
    dateTime?: string;
    date?: string;
  };
}

export interface BigCalendarEvent {
  title: string;
  description: string;
  start: Date;
  end: Date;
  allDay: boolean;
  resource?: any;
}

const googleToBigEvent = (googleEvent: GoogleCalendarEvent, resource: string) => {
  const allDay =
    Boolean(googleEvent.start.date) && Boolean(googleEvent.start.date);
  const bigCalendarEvent: BigCalendarEvent = {
    title: googleEvent.summary,
    description: googleEvent.description,
    start: moment(
      googleEvent.start.date || googleEvent.start.dateTime
    ).toDate(),
    end: moment(googleEvent.end.date || googleEvent.end.dateTime).toDate(),
    allDay,
    resource: { id: resource }
  };
  return bigCalendarEvent;
};
